module.exports = __webpack_public_path__ + "img/studio88.237461ed.webp";